import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/welcome',
  exact: true,
  private: true,
  type: containerTypes.PAGE,
};

export default RouteConfig;
